/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminUserDto } from '../models/AdminUserDto';
import type { EntityModelResponseContainerAdminUserDto } from '../models/EntityModelResponseContainerAdminUserDto';
import type { PagedModelEntityModelAdminUserSimpleDto } from '../models/PagedModelEntityModelAdminUserSimpleDto';
import type { PagedResourcesAssemblerAdminUserSimpleDto } from '../models/PagedResourcesAssemblerAdminUserSimpleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemUserControllerService {
    /**
     * @returns PagedModelEntityModelAdminUserSimpleDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        providerId,
        username,
        roles,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerAdminUserSimpleDto,
        providerId?: number,
        username?: string,
        roles?: Array<'SYSTEM_ADMIN' | 'TFA_REQUIRED' | 'REGISTRATION_NEEDED' | 'MAINTENANCE_NEEDED' | 'PROGRAM_ADMIN' | 'PROGRAM_MANAGER' | 'PROGRAM_CONTROLLER' | 'PROGRAM_MANAGER_ADMIN' | 'CARE_ADMIN' | 'INTEGRATION' | 'DEVICE' | 'SERVICE_TECHNICIAN' | 'ENROLL_TECH' | 'WAREHOUSE_TECH' | 'INTEGRATION_ADMIN'>,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelAdminUserSimpleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/users',
            query: {
                'providerId': providerId,
                'username': username,
                'roles': roles,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: AdminUserDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/users/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static read({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/users/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static update({
        userId,
        requestBody,
    }: {
        userId: number,
        requestBody: AdminUserDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/users/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static suspendUser({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/users/{userId}/enable',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static enabledUser({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/users/{userId}/enable',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static resetTfa({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/users/{userId}/tfa',
            path: {
                'userId': userId,
            },
        });
    }
}
